const BACKEND_NAMESPACE = 'backend';
/**
 * Splits a `namespace:KEY` translation key. A key without a namespace gets `backend`, the default namespace of the
 * console, where i18next looks such a key up unless the `ns` option names another.
 */
export function parseTranslationKey(fullKey) {
    const colonIndex = fullKey.indexOf(':');
    if (colonIndex === -1) {
        return { namespace: BACKEND_NAMESPACE, key: fullKey };
    }
    return {
        namespace: fullKey.substring(0, colonIndex),
        key: fullKey.substring(colonIndex + 1),
    };
}
